import React, { useEffect } from "react";
import "./Blog_Details.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import Common_Back_Header from "../common_components/common_back_header/Common_Back_Header";
import { useDispatch, useSelector } from "react-redux";
import { getblog, getblogById } from "../../features/blog/Slice";
import parse from "html-react-parser";

const Blog_Details = () => {
  const { id } = useParams();

  const singleBlog = useSelector((state) => state.blog.singleBlog);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getblogById(id));
  }, [dispatch, id]);

  const navigate = useNavigate();
  const handleBack = () => {
    navigate(-1);
  };
  const recentBlogs = [
    {
      id: 1,
      title: "Mattress weight vs durability: Is heavier always better?",
      image: "/assets/images/blog/blog_img2.png",
      date: "1 day",
    },
    {
      id: 2,
      title: "Kids’ Mattresses: Safety, Firmness & What Parents Should Know",
      image: "/assets/images/blog/blog_img3.png",
      date: "2 days",
    },
    {
      id: 3,
      title: "Mattress weight vs durability: Is heavier always better?",
      image: "/assets/images/blog/blog_img2.png",
      date: "5 days",
    },
    {
      id: 4,
      title: "Kids’ Mattresses: Safety, Firmness & What Parents Should Know",
      image: "/assets/images/blog/blog_img3.png",
      date: "1 day",
    },
    {
      id: 5,
      title: "Mattress weight vs durability: Is heavier always better?",
      image: "/assets/images/blog/blog_img2.png",
      date: "2 days",
    },
    {
      id: 6,
      title: "Kids’ Mattresses: Safety, Firmness & What Parents Should Know",
      image: "/assets/images/blog/blog_img3.png",
      date: "5 days",
    },
  ];

  const allBlogs = useSelector((state) => state.blog.blog);
  useEffect(() => {
    dispatch(getblog());
  }, [dispatch]);

  return (
    <section className="Blog_Details">
      <div className="container">
        <div className="back">
          <Common_Back_Header />
        </div>
        <div className="blog_details_section">
          <div className="row">
            <div className="col-lg-8 col-md-7">
              <div className="blog_main">
                <h2 className="blog_main_title">{singleBlog.name}</h2>

                <div className="blog_main_image_wrapper">
                  <img
                    src={process.env.REACT_APP_IMG_URL + singleBlog?.image}
                    alt="blog"
                    className="blog_main_image"
                  />
                  <div className="blog_image_overlay">
                    <span>
                      {" "}
                      {new Date(singleBlog.updatedAt).toLocaleDateString(
                        "en-GB",
                        {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        },
                      )}
                    </span>
                    <span>Views: 589</span>
                  </div>
                </div>

                <div className="blog_description">
                  <p className="blog_text">
                    {parse(
                      typeof singleBlog?.description === "string"
                        ? singleBlog.description
                        : "",
                    )}
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-5">
              <div className="recent_blog_sidebar">
                <h5 className="recent_title">Recent Blogs</h5>
                <div className="recent_blog_list">
                  {allBlogs?.data?.map((blog) => (
                    <div key={blog.id} className="recent_blog_card">
                      <img
                        src={process.env.REACT_APP_IMG_URL + blog.image}
                        alt=""
                        className="recent_blog_image"
                      />

                      <div className="recent_blog_overlay">
                        <h6 className="item_title">{blog.name}</h6>

                        <div className="recent_footer">
                          <span>
                            {new Date(blog.updatedAt).toLocaleDateString(
                              "en-GB",
                              {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              },
                            )}
                          </span>
                          <span
                            className="read_btn"
                            onClick={() =>
                              navigate(`/blog/${blog.id}`, {
                                state: blog,
                              })
                            }
                          >
                            Start Reading
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Blog_Details;
